module.exports = __webpack_public_path__ + "img/9.250a9eb5.png";